import { debug as d } from "debug";

const debug = d("cs.LocalStorageService");

const localStorageService = {
  // Save data to localStorage
  save<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      debug("Error saving to localStorage", e);
    }
  },

  // Retrieve data from localStorage
  get<T>(key: string): T | null {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (e) {
      debug("Error getting data from localStorage", e);
      return null;
    }
  },

  // Remove item from localStorage
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      debug("Error removing item from localStorage", e);
    }
  },

  // Clear all data from localStorage
  clear(): void {
    try {
      localStorage.clear();
    } catch (e) {
      debug("Error clearing localStorage", e);
    }
  },
};

export default localStorageService;
